/**
 * Rolling debug trail for table replay capture. Mirrors to the console and is
 * attached to each replay upload so the server log shows what the phone did.
 */

const MAX_EVENTS = 80;
const events = [];
const startedAt = Date.now();

export function replayDebug(event, data = {}) {
  const row = { t: Date.now() - startedAt, ev: event, ...data };
  events.push(row);
  if (events.length > MAX_EVENTS) events.splice(0, events.length - MAX_EVENTS);
  try {
    console.info("[tableReplay]", event, data);
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") window.__ttReplayDebug = events;
}

export function replayDebugSnapshot(limit = 40) {
  return events.slice(-limit);
}

export function describeTrack(track) {
  if (!track) return null;
  let settings = {};
  try {
    settings = track.getSettings?.() || {};
  } catch {
    /* ignore */
  }
  return {
    kind: track.kind,
    state: track.readyState,
    muted: Boolean(track.muted),
    w: settings.width || 0,
    h: settings.height || 0,
    fps: settings.frameRate ? Math.round(settings.frameRate) : 0,
  };
}

/**
 * Media duration in seconds via a detached <video>, or null when the browser
 * cannot tell (fragmented MP4 / WebM without cues report Infinity).
 */
export function probeBlobDurationSec(blob, timeoutMs = 2000) {
  if (!blob?.size || typeof document === "undefined") return Promise.resolve(null);
  return new Promise((resolve) => {
    const url = URL.createObjectURL(blob);
    const video = document.createElement("video");
    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";
    let done = false;
    const finish = (value) => {
      if (done) return;
      done = true;
      window.clearTimeout(timer);
      video.removeAttribute("src");
      try {
        video.load();
      } catch {
        /* ignore */
      }
      URL.revokeObjectURL(url);
      resolve(value);
    };
    const timer = window.setTimeout(() => finish(null), timeoutMs);
    video.onloadedmetadata = () => {
      const d = Number(video.duration);
      finish(Number.isFinite(d) && d > 0 ? d : null);
    };
    video.onerror = () => finish(null);
    video.src = url;
  });
}
